var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.8 200.8",
    style: {
      enableBackground: "new 0 0 200.8 200.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#003247;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,122.8c-7.9,4.9-16.5,7.3-25.4,7.3c-6.6,0-13.3-1.3-20.2-3.9c-6.4-2.5-10.9-4.6-9.8-8.8 c1.1-4.3,6.3-3.5,9.3-3.1c14.8,2.2,28.9-2.9,37-13.4c9.7-12.5,11.6-33,4.2-45.5c-4.8-8.4-15.6-16.1-25-18.1 c-13.5-2.8-28.7,3.5-39.8,16.6c-2.6,3.1-4.7,6.9-8.5,15c-1.4,3.1-2.8,5.8-3.8,7.8c-1.6,3.1-2.8,5.3-5.7,5.2h0 c-1.6-0.1-3-1.1-3.6-2.7l0,0c-1.7-4.7,6-23.4,7.2-26.1c7.8-16.8,17.6-26.1,33.9-32.4c10.8-4.2,20.1-5,31.8-2.9 c24.7,4.4,44.3,25.1,46.6,49.1C202.7,88.6,191.4,111.1,172.3,122.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,82.6c-3.6,8.1-8.5,19-13.8,30.6c-2.1,4.5-20.3,44.3-23,48.6c-6.8,10.7-14.8,17-25.8,20.4 c-3.9,1.2-8.6,1.9-13.2,1.9c-3.3,0-6.5-0.3-9.4-1c-6.7-1.6-16.1-6.3-21.4-10.8c-11.4-9.4-18-23.2-17.9-37.8 c0-14.1,6.3-27.3,17.2-36.1c13.6-11,34.9-13.5,57-6.9c2.2,0.7,6.9,2.1,5.8,6.2c-1.2,4.4-6.5,3.2-10.8,2.2c-2.7-0.6-8.2-1-12.3-1 c-15.6,0.4-28.8,9.2-32.1,21.3c-3.8,14.2,3.3,29.5,16.5,35.8c13.8,6.4,27.9,3.1,37.8-8.8c3.5-4.2,8.1-14.1,9.1-19.6 c1.7-9.8-0.1-21-4.3-25.9l-0.1-0.1c-2.6-3.3-3.2-5.3-2.3-7.3c1.3-2.7,4.6-2.9,7.7-2.8c11,0.4,21.3-7.4,31.5-23.9 c1.3-2.2,3.9-6.6,7.8-4.9l0,0c1.1,0.5,1.8,1.4,2.2,2.5l0,0C131.1,67.3,131.2,67.5,124.5,82.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.473cfc9d.svg";
export { ForwardRef as ReactComponent };